import { render, staticRenderFns } from "./AdvancedSlots.vue?vue&type=template&id=dc873d60&"
import script from "./AdvancedSlots.vue?vue&type=script&lang=js&"
export * from "./AdvancedSlots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports